// Auto-generated by splitter.py — do not regenerate; edit directly.

export const REFUND_REASONS = [
  'Event cancelled by organiser',
  'Duplicate / double payment',
  'Buyer requested refund',
  'Fraudulent transaction',
  'Ticket delivery failed',
  'Chargeback / dispute',
  'Other (specify in notes)',
];


export const BANK_FILE_FORMATS = [
  { id: 'swift-mt103',   label: 'SWIFT MT103',         sub: 'International wires · single payment per record · ISO 20022 envelope available',  ext: '.swift', maxPerBatch: 200,  banks: ['Stanbic', 'Standard Chartered', 'Absa', 'DFCU'] },
  { id: 'pain-001',      label: 'ISO 20022 pain.001',  sub: 'SEPA / pan-African EFT · structured XML · bank-agnostic',                          ext: '.xml',   maxPerBatch: 500,  banks: ['Stanbic', 'Standard Chartered', 'Equity', 'KCB', 'Absa'] },
  { id: 'stanbic-eft',   label: 'Stanbic Bulk EFT',    sub: 'Stanbic internet banking · CSV with branch + account · same-day if before 14:00', ext: '.csv',   maxPerBatch: 1000, banks: ['Stanbic'] },
  { id: 'dfcu-eft',      label: 'DFCU Bulk Payments',  sub: 'DFCU corporate portal · pipe-delimited TXT · supports MoMo + bank',                ext: '.txt',   maxPerBatch: 500,  banks: ['DFCU'] },
  { id: 'pesalink',      label: 'Pesalink (KE)',       sub: 'Kenya inter-bank · CSV · for organizers with Kenyan settlement',                   ext: '.csv',   maxPerBatch: 250,  banks: ['Equity', 'KCB', 'Cooperative', 'I&M'] },
  { id: 'generic-xlsx',  label: 'Generic spreadsheet', sub: 'XLSX with all fields · for manual upload or reconciliation',                       ext: '.xlsx',  maxPerBatch: 2000, banks: ['Any'] },
];


/* ============================================================================
   EVENT INVENTORY — Operational stock, QR codes, seats, holds, credentials
   ============================================================================ */

